import Vue from 'vue';

import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';
import api from '@/api';
import BroadcastChannelService from '@/broadcastChannel/broadcast-channel-service';
import { EVENTS } from '@/broadcastChannel/broadcast-channel.const';
import AnalyticsService from '@/utils/AnalyticsService';

// mutations declarations
export const EXAMPLE_MUTATION = 'EXAMPLE_MUTATION';
export const LOGOUT = 'LOGOUT';
export const LOGIN = 'LOGIN';
export const USER = 'USER';
export const SET_LOADING = 'SET_LOADING';
export const SET_IS_USER_REGISTRATION_LOADING = 'SET_IS_USER_REGISTRATION_LOADING';
export const SET_PUB_SUB_TOKEN = 'SET_PUB_SUB_TOKEN';
export const SET_PUB_SUB_REFRESH_TOKEN = 'SET_PUB_SUB_REFRESH_TOKEN';
export const SET_USER_FROM_DIFFERENT_TAB = 'SET_USER_FROM_DIFFERENT_TAB';
export const SET_IS_LOADING_USER_DATA = 'SET_IS_LOADING_USER_DATA';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[LOGIN](state, token) {
		api.setToken(token);
		Vue.set(state, 'isLoggedIn', true);
	},
	[LOGOUT](state) {
		api.removeToken();
		Vue.set(state, 'isLoggedIn', false);
	},
	[USER](state, user) {
		onSetUser(state, user);
		BroadcastChannelService.postBroadcastMessage(EVENTS.SET_USER, user);
	},
	[SET_USER_FROM_DIFFERENT_TAB](state, user) {
		if (!state.user || user.id === state.user.id) {
			onSetUser(state, user);
		} else {
			// Should never happen. added as protection to sleep at night :)
			console.error('***EXTREME WARNING*** User from different tab is not the same as the current user', { user, stateUser: state.user });
			window.location.reload();
		}
	},
	[SET_LOADING](state, loading) {
		Vue.set(state, 'loading', loading);
	},
	[SET_IS_LOADING_USER_DATA](state, isLoadingUserData) {
		Vue.set(state, 'isLoadingUserData', isLoadingUserData);
	},
	[SET_IS_USER_REGISTRATION_LOADING](state, loading) {
		Vue.set(state, 'isUserRegistrationLoading', loading);
	},
	[SET_PUB_SUB_TOKEN](state, token) {
		Vue.set(state, 'pubSubToken', token);
	},
	[SET_PUB_SUB_REFRESH_TOKEN](state, pubSubRefreshToken) {
		Vue.set(state, 'pubSubRefreshToken', pubSubRefreshToken);
	},
};

const onSetUser = (state, user) => {
	Vue.set(state, 'user', user);
	AnalyticsService.identifyUser(state.user);
};

export default mutations;
